import { PageHero, usePageMeta } from "@/components/primitives";
import { ServiceGroups } from "@/components/blocks1";
import { SolutionsTabs, FinalCTA } from "@/components/blocks2";

export default function Solutions() {
  usePageMeta(
    "TimePe Solutions | Financial Infrastructure for Bharat",
    "One intelligent infrastructure for payments, banking, protection and last-mile access — for consumers, merchants, banks, FinTechs and institutions."
  );
  return (
    <>
      <PageHero
        eyebrow="Solutions"
        lines={["One Intelligent Infrastructure.", "Multiple Financial Journeys."]}
        lead="Payments, banking, insurance and last-mile access — unified by risk intelligence, privacy and compliance at the core."
      />
      <ServiceGroups />
      <SolutionsTabs />
      <FinalCTA />
    </>
  );
}
